import { Button, ButtonProps } from 'antd';
import React from 'react';

interface PrimaryButtonProps extends ButtonProps {
  children: React.ReactNode;
}

export const PrimaryButton = ({
  children,
  className = '',
  ...props
}: PrimaryButtonProps) => {
  return (
    <Button
      type="primary"
      {...props}
      className={`font-android border-none rounded-none font-normal hover-3d !text-black ${className}`}
    >
      <span className="!text-black">
        {children}
      </span>
    </Button>
  );
};
